import React from 'react'

export const CreateSpPins = () => {
  return (
    <div>CreateSpPins</div>
  )
}

